import React from 'react';
import { useState } from 'react';

import { StyleSheet } from 'react-native';

import { CenteredRowContainer } from 'components/layout/centered-row-container';
import { Box } from 'components/ui';
import { useExposeMinimalCartExperiment } from 'experiments/use-enable-minimal-cart-experiment';
import { CustomEventNames } from 'state/amplitude';
import { spacing } from 'styles/constants';

import { MinimalMenuReorderCard } from './minimal-menu-reorder-card';
import { MinimalMenuReorderDetailsDrawer } from './minimal-menu-reorder-details-drawer';
import { useLastMinimalOrderAvailableToReorder } from './use-last-minimal-order-available-to-reorder';

export const MinimalMenuReorderWidget = () => {
  const openDetailEventMessage = CustomEventNames.LAST_ORDER_DETAILS;
  const lastOrder = useLastMinimalOrderAvailableToReorder();
  const [isDetailsDrawerOpen, setIsDetailsDrawerOpen] = useState<boolean>(false);
  const toggleDetailsDrawer = () => setIsDetailsDrawerOpen(!isDetailsDrawerOpen);

  useExposeMinimalCartExperiment(Boolean(lastOrder));

  if (!lastOrder) {
    return null;
  }

  return (
    <CenteredRowContainer>
      {isDetailsDrawerOpen ? (
        <MinimalMenuReorderDetailsDrawer
          order={lastOrder}
          showDrawer={isDetailsDrawerOpen}
          toggleDetailsDrawer={toggleDetailsDrawer}
          openDetailEventMessage={openDetailEventMessage}
        />
      ) : (
        <Box style={styles.cardWrapper}>
          <MinimalMenuReorderCard
            order={lastOrder}
            toggleDetailsDrawer={toggleDetailsDrawer}
            drawerIsOpen={isDetailsDrawerOpen}
          />
        </Box>
      )}
    </CenteredRowContainer>
  );
};

const styles = StyleSheet.create({
  cardWrapper: {
    padding: spacing.$4,
  },
});
